import React from "react";
import "./App.css";
import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import "bootstrap/dist/css/bootstrap.min.css";
import "bootstrap/dist/js/bootstrap.min.js";
import { Navbar } from "./components/Navbar";
import { Account } from "./pages/Account";
import { Home } from "./pages/home/Home";
import { CreatePost } from "./pages/Post/createpost/CreatePost";
import { MyPosts } from "./pages/myposts/MyPosts";
import { UserPage } from "./pages/userpage/UserPage";
import { useState, createContext } from "react";
import { EditPost } from "./pages/Post/editPost/EditPost";
import { Comments } from "./pages/comment/Comments";

interface IContext {
  selectedUsername: string;
  selectedUserId: string;
  selectedPostId: string;
  setSelectedPostId: React.Dispatch<React.SetStateAction<string>>;
  setSelectedUsername: React.Dispatch<React.SetStateAction<string>>;
  setSelectedUserId: React.Dispatch<React.SetStateAction<string>>;
}
export const AppContext = createContext<IContext>({
  selectedUsername: "",
  selectedUserId: "",
  selectedPostId: "",
  setSelectedPostId: () => {},
  setSelectedUsername: () => {},
  setSelectedUserId: () => {},
});

function App() {
  const [selectedUsername, setSelectedUsername] = useState<string>("");
  const [selectedUserId, setSelectedUserId] = useState<string>("");
  const [selectedPostId, setSelectedPostId] = useState<string>("");
  return (
    <div className='App bg-dark text-white min-vh-100'>
      <AppContext.Provider
        value={{ selectedUsername, selectedUserId, setSelectedUsername, setSelectedUserId, selectedPostId, setSelectedPostId }}>
        <Router>
          <Navbar></Navbar>
          <Routes>
            <Route path='/' element={<Home />} />
            <Route path='/account' element={<Account />} />
            <Route path='/createpost' element={<CreatePost />} />
            <Route path='/myposts' element={<MyPosts />} />
            <Route path='/userpage' element={<UserPage />} />
            <Route path='/editPost' element={<EditPost />} />
            <Route path='/comments' element={<Comments />} />
            <Route path='/*' element={<h1>Page not found</h1>} />
          </Routes>
        </Router>
      </AppContext.Provider>
    </div>
  );
}

export default App;
